import { Dispatch } from "redux";
import { AlertSeverity, hideAlert, showAlert } from "./types/alertTypes";

export const showAlertRejectAction = (
  dispatch: Dispatch,
  shortTime?: boolean
) => {
  dispatch(showAlert("Ingresante rechazado correctamente", AlertSeverity.info));
  if (shortTime) hideShortAction(dispatch);
  else hideLargeAction(dispatch);
};

export const showAlertInAction = (dispatch: Dispatch, shortTime?: boolean) => {
  dispatch(
    showAlert("Ingresante aprobado correctamente", AlertSeverity.success)
  );
  if (shortTime) hideShortAction(dispatch);
  else hideLargeAction(dispatch);
};

export const showAlertOutAction = (dispatch: Dispatch, shortTime?: boolean) => {
  dispatch(showAlert("Salida marcada correctamente", AlertSeverity.success));
  if (shortTime) hideShortAction(dispatch);
  else hideLargeAction(dispatch);
};

export const hideLargeAction = (dispatch: Dispatch) => {
  setTimeout(() => {
    dispatch(hideAlert());
  }, 5000);
};

export const hideShortAction = (dispatch: Dispatch) => {
  setTimeout(() => {
    dispatch(hideAlert());
  }, 3000);
};
